export default "__VITE_ASSET__DQeHmbyJ__"